module.exports = __webpack_public_path__ + "static/media/expand-arrows-alt.6641cdb4.svg";